define([
    "./commonScriptModule",
    "text!./nlgScriptEntityEditionGeneral.html"
], function (controllers, template) {
    "use strict";

    controllers.directive("nlgScriptEntityEditionGeneral", [function () {
        return {
            template: template,
            scope: {
                entity: "=",
                isEnabled: "&?"
            },
            controller: "nlgScriptEntityEditionController"
        };
    }]);
});